module.exports = __webpack_public_path__ + "img/icon-track.4f1ac3ec.svg";